import { View, Text, StyleSheet, TouchableOpacity, Dimensions } from "react-native";
import React, { useEffect } from "react";
import Colours from "../../utils/Colours";
import CalendarPicker from "react-native-calendar-picker";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import moment from "moment/moment";

const { width } = Dimensions.get("window");

const CalenderSignUpScreenModal = ({
  hidePullModal,
  selectedDate,
  setSelectedDate,
  saveSetBirthDate,
  mode,
}) => {
  // Calculate min and max selectable dates
  // const maxSelectableDate = moment().subtract(10, 'years').toDate(); // 12 years ago
  // const minSelectableDate = moment().subtract(100, 'years').toDate();

  let minSelectableDate,
    maxSelectableDate,
    disabledDates = [];
  const today = moment().startOf("day");

  if (mode === "dob") {
    // User must be at least 10 years old, max 100 years
    maxSelectableDate = moment().subtract(10, "years").toDate();
    minSelectableDate = moment().subtract(100, "years").toDate();
  } else if (mode === "future") {
    // User can only pick dates starting tomorrow, no upper limit
    minSelectableDate = moment().add(1, "day").toDate();
    // maxSelectableDate = null; // no restriction
    maxSelectableDate = moment().add(8, "days").toDate();
  } else if (mode === "weekend") {
    const currentDay = today.weekday(); // 0=Sun, 1=Mon, ..., 4=Thu, 5=Fri, 6=Sat

    // 1. Set Max Date (e.g., 6 months out)
    maxSelectableDate = moment().add(6, "months").toDate();

    // 2. Determine Minimum Selectable Date (This handles the 'start date' rules)
    let newMinDateMoment = moment(today);

    if (currentDay === 4) {
      // Thursday
      // Rule: Friday inactive, start from Saturday (+2 days)
      newMinDateMoment.add(2, "days");
    } else if (currentDay === 5) {
      // Friday (Weekend)
      // Rule: If current day is a weekend, "blank it" and start next week Friday (+7 days)
      newMinDateMoment.add(7, "days");
    } else if (currentDay === 6) {
      // Saturday (Weekend)
      // Rule: blank it, start next week Friday (+6 days)
      newMinDateMoment.add(6, "days");
    } else if (currentDay === 0) {
      // Sunday (Weekend)
      // Rule: blank it, start next week Friday (+5 days)
      newMinDateMoment.add(5, "days");
    } else {
      // Mon (1), Tue (2), Wed (3)
      // Rule: Start from this week's Friday
      // Days to Friday = 5 - currentDay
      newMinDateMoment.add(5 - currentDay, "days");
    }

    minSelectableDate = newMinDateMoment.startOf("day").toDate();

    // 3. Build the list of disabled dates (all future weekdays: Mon-Thu)
    disabledDates = [];
    let loopDate = moment(today);
    const sixMonthsLater = moment().add(6, "months");

    while (loopDate.isBefore(sixMonthsLater, "day")) {
      const day = loopDate.weekday();
      // Mon (1), Tue (2), Wed (3), Thu (4) are the disabled weekdays
      if (day >= 1 && day <= 4) {
        disabledDates.push(loopDate.toDate());
      }
      loopDate.add(1, "day");
    }
  } else {
    // Default case
    minSelectableDate = today.toDate();
    maxSelectableDate = null;
  }

  useEffect(() => {
    //console.log('selectedDate', selectedDate)
  }, [selectedDate]);

  return (
    <View style={styles.container}>
      <TopHeaderComponent
        hideScreen={hidePullModal}
        headerText={mode === "weekend" ? "Choose your weekend" : "Select Date"}
      />

      {/* Calendar Section */}
      <View style={styles.calendarContainer}>
        <CalendarPicker
          onDateChange={setSelectedDate}
          width={width * 0.8} // Adjusts dynamically based on screen width
          todayBackgroundColor={Colours.DARKGRAY}
          todayTextStyle={{ color: "#FFFFFF" }}
          selectedDayColor={Colours.PRIMARY}
          selectedDayTextColor="#FFFFFF"
          maxDate={maxSelectableDate}
          minDate={minSelectableDate}
          disabledDates={disabledDates}
          disabledDatesTextStyle={{ color: "#999" }} // grey out disabled
          //   customDatesStyles={customDatesStyles}
        />
      </View>

      {/* Save Button */}
      <TouchableOpacity style={styles.saveButton} onPress={saveSetBirthDate}>
        <Text style={styles.saveText}>Save</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  calendarContainer: {
    width: "90%", // Responsive width
    padding: 20,
    marginVertical: 15,
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderRadius: 15,
    alignSelf: "center", // Centers on all screen sizes
  },
  saveButton: {
    width: "90%", // Makes button responsive
    height: 60,
    backgroundColor: Colours.DARKGRAY,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 15,
    marginTop: 15,
    alignSelf: "center", // Centers button
  },
  saveText: {
    color: "white",
    fontSize: 17,
    fontFamily: "Sen-Bold",
  },
});

export default CalenderSignUpScreenModal;
